<ng-container *ngIf="(surveyViewerService.activeSurvey$ | async).form.get(this.question.key) && createUser">
  <div data-testId="checkboxForm">
    <div class="vertival-checkbox-group">
      <div *ngFor="let statementKey of question.statementsOrder">
        <mat-checkbox [color]="'primary'" class="checkbox-button"
                      (change)="answerChange(statementKey)"
                      [formControl]="$any(questionFormControl.get(statementKey))"
                      data-testId="checkbox">
          <img
            *ngIf="surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang) && question.useImage"
            src="{{surveyViewerService.getStatementLabelImageUrl(question, statementKey, activeLang)}}"
            alt="image" [style.width]="question.imageSize+'px'"
            class="image-label"
          >
          {{question.statements[statementKey].label | translateLabel: activeLang}}
        </mat-checkbox>

        <ng-container *ngIf="commentsFormControl.get(statementKey) && questionFormControl.get(statementKey).value">
          <mat-form-field [color]="'primary'" appearance="outline" class="w-full comment-field"
          >
            <input appNoPaste [errorStateMatcher]="errorMatcher" type="text" matInput
                   [formControl]="$any(commentsFormControl.get(statementKey))"
                   (input)="onInput($event.target.value, statementKey)"
                   (blur)="onBlur($event.target.value.trim(), statementKey)">
            <mat-error>
              {{'Le commentaire ne peut être vide'|transloco}}.
            </mat-error>
          </mat-form-field>
          <ng-container *ngIf="isValidAI[statementKey]| async as isValidAI">
            <div class="warning-message mb-8" *ngIf="!isValidAI.isValid">**** {{isValidAI.explication}}</div>
          </ng-container>
        </ng-container>

      </div>
    </div>

    <mat-error
      *ngIf="surveyViewerService.activeSurvey$.value.form.get(question.key).hasError(minRowErrorFnName) && surveyViewerService.allFormControlsMarkedAsTouched$.value">
      {{surveyViewerService.errorMessages.minCheckboxSelection(question.minAnswers.rows) | translateLabel: activeLang}}
    </mat-error>
  </div>
</ng-container>
